// extracted by mini-css-extract-plugin
export var locationCard = "_ex-0";